import { useDeleteRecommendation } from '@/api/recommendation/recommendation.hooks';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog';
import { Recommendation } from '@repo/types/src/recommendation';
import { Trash2 } from 'lucide-react';
import { useState } from 'react';
import { toast } from 'sonner';

type DeleteRecommendationProps = {
  item: Recommendation;
  refetch: () => void;
};

export const DeleteRecommendation = ({
  item,
  refetch,
}: DeleteRecommendationProps) => {
  const mutation = useDeleteRecommendation();
  const [open, setOpen] = useState(false);

  const handleDelete = () => {
    mutation.mutate(item.id, {
      onSuccess: () => {
        setOpen(false);
        refetch();
        toast.success('Recommandation supprimée avec succès', {
          duration: 3000,
        });
      },
      onError: () => {
        toast.error('Erreur lors de la suppression', { duration: 3000 });
      },
    });
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button variant="destructive" size="sm" disabled={mutation.isPending}>
          <Trash2 size={16} />
        </Button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle className="text-center">
            Supprimer la recommandation
          </DialogTitle>
          <DialogDescription className="text-center">
            Êtes-vous sûr de vouloir supprimer cette recommandation ? Cette
            action est irréversible.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="flex gap-2">
          <DialogClose asChild>
            <Button variant="ghost" disabled={mutation.isPending}>
              Annuler
            </Button>
          </DialogClose>
          <Button
            variant="destructive"
            onClick={handleDelete}
            disabled={mutation.isPending}
          >
            {mutation.isPending ? 'Suppression...' : 'Supprimer'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
